import type { AddSkillSchemaType } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-add-skill-dialog';
import { SkillLevels } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-add-skill-dialog';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Card, CardContent } from '@eliadmin/core/src/components/ui/card';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiEdit, FiTrash } from 'react-icons/fi';

type JobportalSkillCardProps = {
  skill: AddSkillSchemaType;
  onSkillEditClick: (skill: AddSkillSchemaType) => void;
  onSkillDeleteClick: (skill: AddSkillSchemaType) => void;
  showDescription?: boolean; // Optional prop to control description visibility
};

export const JobportalSkillCard = ({
  skill,
  onSkillEditClick,
  onSkillDeleteClick,
  showDescription,
}: JobportalSkillCardProps) => {
  const { t } = useTranslations();

  const getSkillLevelTranslateString = () => {
    switch (skill.level) {
      case SkillLevels.ABSOLUTE_BEGINNER:
        return t('text975');
      case SkillLevels.BEGINNER:
        return t('text976');
      case SkillLevels.INTERMEDIATE:
        return t('text977');
      case SkillLevels.ADVANCED:
        return t('text978');
      case SkillLevels.EXPERT:
        return t('text979');
      default:
        return '';
    }
  };

  return (
    <Card className={cn('border border-border', 'ea-jobportal-add-skill__card')}>
      <CardContent
        className={cn(
          'flex flex-col justify-between gap-4 p-6 sm:flex-row sm:gap-0',
          'ea-jobportal-add-skill__card-content',
        )}
      >
        <div className={cn('flex flex-col gap-1', 'ea-jobportal-add-skill__card-info')}>
          <h3 className={cn('font-semibold', 'ea-jobportal-add-skill__card-info-maintext')}>
            {t(skill.name)}
          </h3>
          <p
            className={cn(
              'line-clamp-2 text-muted-foreground',
              'ea-jobportal-add-skill__card-info-subtext',
            )}
          >
            {showDescription ? skill.description : getSkillLevelTranslateString()}
          </p>
        </div>
        <div className={cn('flex gap-2', 'ea-jobportal-add-skill__card-buttons')}>
          <Button
            className={cn(
              'flex h-12 w-12 gap-2 p-0 text-primary',
              'ea-jobportal-add-skill__card-edit-button',
            )}
            type="button"
            variant={'accent'}
            onClick={() => onSkillEditClick(skill)}
          >
            <FiEdit />
          </Button>
          <Button
            className={cn(
              'flex h-12 w-12 gap-2  p-0',
              'ea-jobportal-add-skill__card-delete-button',
            )}
            type="button"
            variant={'destructive'}
            onClick={() => onSkillDeleteClick(skill)}
          >
            <FiTrash />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
